/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
async function checkFreeShippingBar() {
  const FREE_SHIPPING_HANDLES = [
    'rotterdam-half-box-1',
  ];

  const cart = document.querySelector('#drawer-cart');
  if (!cart) return;
  
  const bar = cart.querySelector('free-shipping-bar');
  if (!bar) return;

  try {
    const response = await fetch('/cart.js');
    const cartData = await response.json();

    if (cartData.items.length === 0) {
      bar.style.display = '';
      return;
    }

    const allFree = cartData.items.every(item =>
      FREE_SHIPPING_HANDLES.includes(item.handle)
    );

    bar.style.display = allFree ? 'none' : '';
  } catch (e) {
    console.error('checkFreeShippingBar error:', e);
  }
}

const originalFetch = window.fetch;
window.fetch = async function(...args) {
  const result = await originalFetch.apply(this, args);
  const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
  
  if (url.includes('/cart/') || url.includes('/cart.js')) {
    setTimeout(checkFreeShippingBar, 300);
  }
  
  return result;
};

document.addEventListener('DOMContentLoaded', checkFreeShippingBar);
document.addEventListener('cart:updated', checkFreeShippingBar);